import { render, staticRenderFns } from "./DebtInputs.vue?vue&type=template&id=6841d7ab&scoped=true"
import script from "./DebtInputs.vue?vue&type=script&lang=js"
export * from "./DebtInputs.vue?vue&type=script&lang=js"
import style0 from "./DebtInputs.vue?vue&type=style&index=0&id=6841d7ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6841d7ab",
  null
  
)

export default component.exports